// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ua-2";
export var chatLink = "_ua-0";
export var chatText = "_ua-1";